module.exports = __webpack_public_path__ + "img/xterra-C-logo.052ea581.png";